/* eslint-disable @typescript-eslint/no-unused-vars */
import { Grid } from "@mui/material";
import coinIcon from "assets/coin.png";
import { AppBarUserBox } from "./styled";
//import { CrownIcon } from "utils/svgIcons";
import { useWebStoreContext } from "contexts";
import useBreakpoints from "hooks/useBreakpoints";
import { GenericPointBalance, ProfileImage } from "./lib";
import LoyaltyPoints from "./lib/LoyaltyPoints";

export const AppBarUser = () => {
	const { authToken, userTracker } = useWebStoreContext();
	const { isSmDown } = useBreakpoints();
	const inventory = userTracker?.inventory;

	return (
		<AppBarUserBox sx={{ width: { xs: 36, sm: 62 } }}>
			{userTracker && authToken && (
				<Grid
					container
					position="absolute"
					right={{ xs: 45, sm: 67 }}
					spacing={0.5}
					width="max-content"
				>
					<Grid item>
						<GenericPointBalance>
							<img src={coinIcon} alt="" />
							<div>{inventory?.coins?.toLocaleString("en-US") ?? 0}</div>
						</GenericPointBalance>
					</Grid>
					<Grid item>
						<LoyaltyPoints
							points={userTracker?.isFirstLogin ? 0 : userTracker.loyaltyPoints}
						/>
					</Grid>
				</Grid>
			)}
			<ProfileImage />
		</AppBarUserBox>
	);
};
